// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N700, N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { LAYER_HEIGHT } from '../../../common/constants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ExpandViewContainer = styled.div({
	display: 'flex',
	justifyContent: 'flex-end',
	paddingBlockStart: token('space.200', '16px'),
	paddingInline: token('space.100', '8px'),
	paddingBottom: token('space.050', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TimeZone = styled.span({
	color: token('color.text.subtlest', N700),
	marginLeft: token('space.100', '8px'),
	whiteSpace: 'nowrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const LayerName = styled.h4({
	font: token('font.heading.xxsmall'),
	marginTop: token('space.250', '20px'),
	color: token('color.text.subtle', N800),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: LAYER_HEIGHT,
	padding: `0 0 ${token('space.050', '4px')} ${token('space.200', '16px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CalendarWrapper = styled.div({
	padding: `0 ${token('space.100', '8px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	padding: `0 0 ${token('space.150', '12px')} 0`,
});
